import React from "react";
import CustomTooltip from "./CustomTooltip";

// A compact label component that mimics Form.Item label, with required star:
export const CustomLabel: React.FC<{
  label: string;
  required?: boolean;
  tooltip?: React.ReactNode | string;
  useHtml?: boolean;
}> = ({ label, required, tooltip, useHtml }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 8, paddingBottom: "8px" }}>
    <span>
      {label}
      {required && (
        <span
          style={{
            display: "inline-block",
            marginInlineStart: 4,
            color: "#ff4d4f",
            fontSize: 14,
            fontFamily: "SimSun, sans-serif",
            lineHeight: 1,
          }}
        >
          *
        </span>
      )}
    </span>
    {tooltip && (
      <CustomTooltip content={tooltip} useHtml={useHtml} placement="bottom" />
    )}
  </span>
);
